import React from "react";
import Background from "../../components/Background/Background";

const Login = () => {
  return (
    <>
     <Background />
    </>
  );
};

export default Login;

